document.addEventListener('DOMContentLoaded', () => {

  // Wishlist set loading state
  const wishlistEmptyDiv = document.querySelector('.account-wishlist-details-container-empty-state')
  if (wishlistEmptyDiv) {
    wishlistEmptyDiv.classList.add('wishlist-loading')
  }

  // Wishlist add to cart
  function onAddToCartClick(e){
    e.preventDefault()
    var productId = e.target.getAttribute("data-product-id")
    var variantId = e.target.getAttribute("data-variant-id")
    var listId = e.target.getAttribute("data-list-id")
    var du = e.target.getAttribute("data-url")
    e.target.innerHTML = "Adding..."
    window._swat.replayAddToCart(
     {empi: productId, du: du},
     variantId,
     function() {
       e.target.innerHTML = "Added to Bag"
       var newHash = 'wishlist'
       var newURL = window.location.pathname + '?lid=' + listId + '#' + newHash
       var currentUrl = window.location.href
       var url = new URL(currentUrl)
       var lid = url.searchParams.get('lid')
       if (lid !== null) {
         window.location.reload()
       } else {
         window.location.href = newURL
       }
       console.log("Successfully added product to cart.")
     },
     function(e) { 
      console.log(e)
      if (e == "Variant is in stock") {
        alert("Out of stock")
      }
     }
    )
  }

  // Wishlist ATC listeners
  function wishlistATCClickListeners(){
    const addToCartButtons = document.querySelectorAll('.add-to-cart')
    addToCartButtons.forEach((btn) => { btn.addEventListener('click', onAddToCartClick, false) })
  }

  // delete wishlist
  function deleteWishlist(swat, listID) {
    let onSuccess = function(deletedListObj) {
      console.log(`Successfully deleted the List, ${listID}`, deletedListObj)
      const deleteConfirmPopup = document.querySelector('[data-wishlist-confirm-delete-popup]')
      deleteConfirmPopup && deleteConfirmPopup.classList.remove('popup-active')
      window.location.hash = "wishlist"
      window.location.reload()
    }
    let onError = function(error) { console.log(`Error while deleting the List, ${listID}`, error) }
    swat.deleteList(listID, onSuccess, onError)
  }

  // wishlist delete popup
  function deleteListConfirmationPopup(listID, listName) {
    // Close settings popup
    const settingsPopup = document.querySelector('[data-wishlist-settings-popup]')
    settingsPopup && settingsPopup.classList.remove('popup-active')
    // Open confirmation popup
    const deleteConfirmationPopup = document.querySelector("[data-wishlist-confirm-delete-popup]")
    if (!deleteConfirmationPopup) return
    deleteConfirmationPopup.classList.add('popup-active')
    // Update List name
    const deleteConfirmationPopupTitle = document.querySelector("[data-wishlist-popup-title-delete]")
    if (!deleteConfirmationPopupTitle) return
    deleteConfirmationPopupTitle.innerHTML = listName

    const deleteWishlistConfirmButton = document.querySelector("[data-wishlist-confirm-delete-popup-save-btn]")
    if (!deleteWishlistConfirmButton) return
    deleteWishlistConfirmButton.setAttribute('data-delete-list-id', listID)
    deleteWishlistConfirmButton.setAttribute('data-delete-list-name', listName)
  }

  // Wishlist Render Product Card
  function renderWishListDetailsProducts(listDetails) {
    var productCardMarkup = `
      <ul class="view-wishlist_products">
        {{#products}}
          <li class="view-wishlist_product">
            <a class="" href="{{du}}">
              <span class="visually-hidden">{{dt}}</span>
            </a>
            <a class="" href="{{du}}">
              <div class="view-wishlist_product--image">
                <img class="" src="{{iu}}" />
              </div>
            </a>
            <div class="view-wishlist_product--info" aria-hidden="true">
              <div class="brand">{{bt}}</div>
              <a class="" href="{{du}}">
                <div class="name">{{dt}}</div>
              </a>
              <dl class="price" data-price="">
                <span class="" data-sale-price="">{{cu}}{{pr}}</span>
              </dl>
            </div>
            <a href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" data-list-id="${listDetails.list.lid}" class="add-to-cart view-wishlist_product--cta">
              {{#isInCart}}Added to bag{{/isInCart}}
              {{^isInCart}}Add to bag{{/isInCart}}
            </a>
          </li>
        {{/products}}
      </ul>
    `
    var wishlistContentsContainer = document.getElementById("wishlist-items-container")
    _swat.fetchWrtEventTypeET(
      function() {
        var formattedWishlistProducts = listDetails.items.map(function(p){
          p = SwymUtils.formatProductPrice(p)
          p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart)
          return p
        })
        const productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, { products: formattedWishlistProducts })
        wishlistContentsContainer.innerHTML = productCardsMarkup
        wishlistATCClickListeners()
      },
      window._swat.EventTypes.addToWishList
    )
  }

  // Wishlist open share popup
  function openSharePopup(link) {
    const sharePopup = document.querySelector("[data-wishlist-share-popup]")
    const sharePopupLinkField = document.querySelector("[data-wishlist-share-popup-link-field]")
    const sharePopupLinkCopyBtn = document.querySelector("[data-wishlist-share-popup-save-btn]")
    if (!sharePopup && !sharePopupLinkField && sharePopupLinkCopyBtn) return
    sharePopup.classList.add('popup-active')
    sharePopupLinkField.value = link
    sharePopupLinkCopyBtn.addEventListener('click', (e) => {
      sharePopupLinkField.select()
      sharePopupLinkField.setSelectionRange(0, 99999) // For mobile devices
      navigator.clipboard.writeText(sharePopupLinkField.value).then(function() { //solution for focus issues
        sharePopupLinkCopyBtn.innerHTML = 'Link copied'
      })
    })
  }

  // Wishlist generating shared link url
  function generateSharedListURL(swat, listID) {
    let onSuccess = (link) => { openSharePopup(link) }
    let onError = (error) => { console.log('Error while generating the link', error) }
    swat.generateSharedListURL(listID, onSuccess, onError)
  }

  // WishList Render Details Page
  function renderWishListDetailsPage(swat, listDetails) {
    const wishlistAccountDetailsTitle = document.querySelector('.account-wishlist-details-header-title')
    const wishlistAccountDetailsEmpty = document.querySelector('.account-wishlist-details-empty')
    const wishlistAccountDetailsSettingsBtn = document.querySelector('.account-wishlist-details-header-settings')
    const wishlistAccountDetailsShareBtn = document.querySelector('[data-wishlist-share-button]')
    if (wishlistAccountDetailsTitle && wishlistAccountDetailsSettingsBtn && wishlistAccountDetailsShareBtn && wishlistAccountDetailsEmpty) {
      wishlistAccountDetailsTitle.innerHTML = listDetails.list.lname
      if (listDetails.list.cnt === 0) {
        wishlistAccountDetailsEmpty.classList.add('account-wishlist-details-empty-active')
      } else {
        wishlistAccountDetailsEmpty.classList.remove('account-wishlist-details-empty-active')
      }
      wishlistAccountDetailsSettingsBtn.addEventListener('click', (e) => {
        e.preventDefault()
        openWishListSettingsPopupWithAttr(listDetails.list.lid, listDetails.list.lname)
      })
      wishlistAccountDetailsShareBtn.addEventListener('click', (e) => {
        e.preventDefault()
        generateSharedListURL(swat, listDetails.list.lid)
      })
    }
  }

  // Wishlist List and Building Details Page
  function fetchListDetails(swat, listID) {
    let listConfig = { "lid": listID }
    let onSuccess = function(listDetails) {
      renderWishListDetailsPage(swat, listDetails)
      renderWishListDetailsProducts(listDetails)
    }
    let onError = function(error) { console.log("Error while fetching List details", error) }
    swat.fetchListDetails(listConfig, onSuccess, onError)
  }

  // Wishlist page close
  function closeListDetailsPage() {
    // window.scrollTo(0, 0)
    const wishlistAccountContainer = document.querySelector('.account-wishlist-container')
    const wishlistAccountContainerSideBar = wishlistAccountContainer?.querySelector('.account-wishlist-sidebar')
    const wishlistAccountContainerList = wishlistAccountContainer?.querySelector('.account-wishlist-details-list')
    const wishlistAccountContainerDetails = wishlistAccountContainer?.querySelector('.account-wishlist-container-details')
    if (wishlistAccountContainerSideBar && wishlistAccountContainerList && wishlistAccountContainerDetails) {
      wishlistAccountContainerSideBar.classList.remove('hidden')
      wishlistAccountContainerList.classList.remove('hidden')
      wishlistAccountContainerDetails.classList.remove('account-wishlist-container-details-active')
    }
  }

  // Wishlist page details
  function openListDetailsPage(swat, listID) {
    // window.scrollTo(0, 0)
    const wishlistAccountContainer = document.querySelector('.account-wishlist-container')
    const wishlistAccountContainerSideBar = wishlistAccountContainer?.querySelector('.account-wishlist-sidebar')
    const wishlistAccountContainerList = wishlistAccountContainer?.querySelector('.account-wishlist-details-list')
    const wishlistAccountContainerDetails = wishlistAccountContainer?.querySelector('.account-wishlist-container-details')
    if (wishlistAccountContainerSideBar && wishlistAccountContainerList && wishlistAccountContainerDetails) {
      wishlistAccountContainerSideBar.classList.add('hidden')
      wishlistAccountContainerList.classList.add('hidden')
      wishlistAccountContainerDetails.classList.add('account-wishlist-container-details-active')
    }
    fetchListDetails(swat, listID)
  }

  // Wishlist create new 
  function createNewWishList (swat, listName) {
    let listConfig = { 'lname': listName }
    let onSuccess = function() { 
      window.location.hash = 'wishlist'
      window.location.reload()
    }
    let onError = function(error) { console.log('Error while creating a List', error)}
    swat.createList(listConfig, onSuccess, onError)
  }
  
  // Wishlist saving settings
  function saveWishlistSettings(swat, button, listName) {
    const listID = button.dataset.listId
    if (!listID) return
    var listUpdateConfig = { 'lid': listID, 'lname': listName }
    let onSuccess = function() { 
      window.location.hash = 'wishlist'
      window.location.reload()
    }
    let onError = function(error) { console.log('Error updating the List', error) }
    swat.updateList(listUpdateConfig, onSuccess, onError)
  }

  // Wishlist settings popup
  function openWishListSettingsPopupWithAttr(linkId, listName) {
    const settingsPopup = document.querySelector('[data-wishlist-settings-popup]')
    const listNameInput = settingsPopup.querySelector('[data-wishlist-settings-popup-title]')
    const saveButton = settingsPopup.querySelector('[data-wishlist-settings-popup-save-btn]')
    const deleteButton = settingsPopup.querySelector('[data-wishlist-popup-delete-button]')
    if (!settingsPopup && !listNameInput && !saveButton && !deleteButton) return
    settingsPopup.classList.add('popup-active')
    listNameInput.value = listName
    saveButton.setAttribute('data-list-id', linkId)
    deleteButton.setAttribute('data-delete-list-id', linkId)
    deleteButton.setAttribute('data-delete-list-name', listName)
  }

  // Wishlist new list popup
  function openNewListPopup() {
    const newListPopup = document.querySelector('[data-wishlist-new-list-popup]')
    newListPopup && newListPopup.classList.add('popup-active')
  }

  // Wishlist Products Carousel
  function buildWishListProductsCarousel() {
    setTimeout(() => {
      const newSwiperEls = document.querySelectorAll('.account-wishlist-details-list .swiper')
      newSwiperEls.forEach((swiperEl) => {
        new Swiper(swiperEl, {
          loop: false,
          slidesPerView: 3.369,
          slidesPerGroup: 1,
          spaceBetween: 20
        })
      })
    }, 100)
  }

  function buildWishListWithContent(swat, lists) {
    console.log("HAS LIST")
    return;
  
    const wishlistEmptyState = document.querySelector('.account-wishlist-details-container-empty-state')
    if (wishlistEmptyState) { wishlistEmptyState.remove() }

    const wishlistNewListButton = document.querySelector('[data-wishlist-new-list-button]')
    if (wishlistNewListButton) {
      wishlistNewListButton.classList.add('active')
    }
  
    const listContainer = document.querySelector('.account-wishlist-details-list')
    const itemTemplate = document.querySelector('#account-wishlist-details-template')
  
    lists.forEach((list) => {
      if (!itemTemplate) return
      let template = itemTemplate.innerText
      template = template.replace(/\[\[LIST_TITLE\]\]/g, list.lname)
      const newDiv = document.createElement('div')
      newDiv.innerHTML = template
      if (list.cnt === 0) {
        const emptyStateWrapper = newDiv.firstElementChild.querySelector('.account-wishlist-details-template-empty')
        emptyStateWrapper && emptyStateWrapper.classList.add('account-wishlist-details-template-empty-active')
      }
  
      const viewLink = newDiv.firstElementChild.querySelector('.view-link')
      viewLink.dataset.linkId = list.lid
  
      const settingsBtn = newDiv.firstElementChild.querySelector('[data-wishlist-settings-button]')
      if (settingsBtn) {
        settingsBtn.dataset.linkId = list.lid
        settingsBtn.dataset.listName = list.lname
      }
  
      const swiperWrapper = newDiv.firstElementChild.querySelector('.group-details .swiper-wrapper')
      list.listcontents.forEach((item) => {
        const newSlide = document.createElement('div')
        newSlide.classList.add('swiper-slide')
        newSlide.classList.add('slide')
        const newImg = document.createElement('img')
        newImg.classList.add('wishlist-item-image')
        newImg.src = item.iu
        newImg.alt = item.dt
        newSlide.appendChild(newImg)
        swiperWrapper && swiperWrapper.appendChild(newSlide)
      })
      listContainer && listContainer.appendChild(newDiv.firstElementChild)
    })

    // Buttons selectors and listeners
    const settingsButton = document.querySelectorAll('[data-wishlist-settings-button]')
    settingsButton && settingsButton.forEach((settingsBtn) => {
      const linkId = settingsBtn.dataset.linkId
      const listName = settingsBtn.dataset.listName
      if (!linkId && !listName) return
      settingsBtn.addEventListener('click', (e) => {
        e.preventDefault()
        openWishListSettingsPopupWithAttr(linkId, listName)
      })
    })
    const settingsPopupCloseButton = document.querySelectorAll('[data-wishlist-settings-popup-close]')
    settingsPopupCloseButton && settingsPopupCloseButton.forEach((popupCloseButton) => {
      popupCloseButton.addEventListener('click', (e) => {
        e.preventDefault()
        const settingsPopup = document.querySelector('[data-wishlist-settings-popup]')
        settingsPopup && settingsPopup.classList.remove('popup-active')
      })
    })
    const settingsPopupSaveButton = document.querySelector('[data-wishlist-settings-popup-save-btn]')
    settingsPopupSaveButton && settingsPopupSaveButton.addEventListener('click', (e) => {
      e.preventDefault()
      const wishListPopupInput = document.querySelector('[data-wishlist-settings-popup-title]')
      const wishListPopupInputValue = wishListPopupInput?.value
      if (wishListPopupInputValue) saveWishlistSettings(swat, settingsPopupSaveButton, wishListPopupInputValue)
    })
    const viewListDetailsButtons = document.querySelectorAll('[data-wishlist-details-button]')
    viewListDetailsButtons && viewListDetailsButtons.forEach((detailsBtn) => {
      const linkId = detailsBtn.dataset.linkId
      if (!linkId) return
      detailsBtn.addEventListener('click', (e) => {
        e.preventDefault()
        openListDetailsPage(swat, linkId)
      })
    })
    const wishlistDetailsBackButton = document.querySelector('[data-account-wishlist-details-back]')
    wishlistDetailsBackButton && wishlistDetailsBackButton.addEventListener('click', (e) => {
      e.preventDefault()
      var currentUrlWithoutQuery = window.location.origin + window.location.pathname
      window.history.replaceState({}, document.title, currentUrlWithoutQuery)
      closeListDetailsPage()
    })
    const sharePopupCloseButton = document.querySelectorAll('[data-wishlist-share-popup-close]')
    sharePopupCloseButton && sharePopupCloseButton.forEach((shareCloseBtn) => {
      shareCloseBtn.addEventListener('click', (e) => {
        e.preventDefault()
        const settingsPopup = document.querySelector('[data-wishlist-share-popup]')
        settingsPopup && settingsPopup.classList.remove('popup-active')
      })
    })
    const settingsPopupDeleteButton = document.querySelector('[data-wishlist-popup-delete-button]')
    settingsPopupDeleteButton && settingsPopupDeleteButton.addEventListener('click', (e) => {
      e.preventDefault()
      const deleteListID = settingsPopupDeleteButton.dataset.deleteListId
      const deleteListName = settingsPopupDeleteButton.dataset.deleteListName
      if (deleteListID && deleteListName) deleteListConfirmationPopup(deleteListID, deleteListName)
    })
    const confirmDeleteButton = document.querySelector('[data-wishlist-confirm-delete-popup-save-btn]')
    confirmDeleteButton && confirmDeleteButton.addEventListener('click', (e) => {
      e.preventDefault()
      const listID = confirmDeleteButton.dataset.deleteListId
      deleteWishlist(swat, listID)
    })
    const deletePopupCloseButton = document.querySelectorAll('[data-wishlist-confirm-delete-popup-close]')
    deletePopupCloseButton && deletePopupCloseButton.forEach((deletePopupCloseBtn) => {
      deletePopupCloseBtn.addEventListener('click', (e) => {
        e.preventDefault()
        const deletePopupDiv = document.querySelector('[data-wishlist-confirm-delete-popup]')
        deletePopupDiv && deletePopupDiv.classList.remove('popup-active')
      })
    })

    buildWishListProductsCarousel()
  
  }

  function newWishlistListeners(swat) {
    // New Wishlist
    const newListPopupClose = document.querySelectorAll('[data-wishlist-new-list-popup-close]')
    newListPopupClose && newListPopupClose.forEach((newListPopupCloseBtn) => {
      newListPopupCloseBtn.addEventListener('click', (e) => {
        e.preventDefault()
        const newListPopup = document.querySelector('[data-wishlist-new-list-popup]')
        newListPopup && newListPopup.classList.remove('popup-active')
      })
    })
    const wishlistNewListButton = document.querySelector('[data-wishlist-new-list-button]')
    wishlistNewListButton && wishlistNewListButton.addEventListener('click', (e) => {
      e.preventDefault()
      openNewListPopup(swat)
    })
    const newListSaveButton = document.querySelector('[data-wishlist-new-list-popup-save-btn]')
    newListSaveButton && newListSaveButton.addEventListener('click', (e) => {
      e.preventDefault()
      const wishListPopupInput = document.querySelector('[data-wishlist-new-list-popup-title]')
      const wishListPopupInputValue = wishListPopupInput?.value
      if (wishListPopupInputValue) createNewWishList(swat, wishListPopupInputValue)
    })
  }

  function buildDefaultWishListView () {
    // Wishlist set loading state
    const wishlistEmptyDiv = document.querySelector('.account-wishlist-details-container-empty-state')
    if (wishlistEmptyDiv) {
      wishlistEmptyDiv.classList.remove('wishlist-loading')
    }
    const wishlistNewListButton = document.querySelector('[data-wishlist-new-list-button]')
    if (wishlistNewListButton) {
      wishlistNewListButton.classList.add('active')
    }
  }
  
  function checkWishListAvailable() {
    var isListLogged = false
    const functionInterval = setInterval(functionIntervalTimer, 200)
    function functionIntervalTimer() {

      function swymLoadCallback(swat) {
        if (swat) {
          newWishlistListeners(swat)
          const wishListLoaded = (lists) => {

            // Open Wishlist Details view if URL has lid param
            var queryString = window.location.search
            var queryParams = new URLSearchParams(queryString)
            var listId = queryParams.get('lid')
            if(listId) openListDetailsPage(swat, listId)

            // Check list state to build list view or default state
            if (!lists) {
              return
            } else if (lists.length === 0) {
              buildDefaultWishListView()
            } else if (!isListLogged) {
              isListLogged = true
              console.log(lists)
              clearInterval(functionInterval)
              buildWishListWithContent(swat, lists)
            }
          }
          const wishListLoadError = (error) => { console.log('error loading wishlists', error) }
          swat.fetchLists({
            callbackFn: wishListLoaded,
            errorFn: wishListLoadError
          })
        } else { console.log('swat not defined') }
      }
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
      }
      window.SwymCallbacks.push(swymLoadCallback)
    }
  }

  checkWishListAvailable()

  const formatSentenceCase = (str) => {
    const allLower = str.toLowerCase()
    return allLower.charAt(0).toUpperCase() + allLower.slice(1)
  }

  // nav links
  const navLinks = document.querySelectorAll('.account-nav li a:not([href="/a/account/shopify-login"])')
    console.log('navLinks');
    console.log(navLinks);
  navLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const target = link.dataset.accountTabTarget
      navLinks.forEach((link) => { link.parentElement.classList.remove('selected') })
      const accountSections = document.querySelectorAll('.account-section')
      accountSections.forEach((section) => { section.classList.remove('selected') })
      link.parentElement.classList.add('selected')
      const selectedSections = document.querySelectorAll('.account-section[data-account-tab="' + target + '"]')
      selectedSections.forEach((section) => { section.classList.add('selected') })
      const pageTitle = document.querySelector('.customer-hero .title')
      pageTitle.innerText = formatSentenceCase(link.innerText)
      const accountContainer = document.querySelector('.account-container')
      if (target === 'rewards' || target === 'wishlist') {
        accountContainer && accountContainer.classList.add('no-sidebar')
      } else if (accountContainer.classList.contains('no-sidebar')) {
        accountContainer && accountContainer.classList.remove('no-sidebar')
      }
      return false
    })
  })

  // form edit buttons
  const editButtons = document.querySelectorAll('.account-settings-group .edit-link')
  editButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      let nearestGroup = button.closest('.account-settings-group-input')
      if (!nearestGroup) {
        nearestGroup = button.closest('.account-settings-group')
      }
      if (nearestGroup.classList.contains('mid-edit')) {
        nearestGroup.classList.remove('mid-edit')
        button.innerText = 'EDIT'
      } else {
        nearestGroup.classList.add('mid-edit')
        button.innerText = 'CANCEL'
      }
      return false
    })
  })

  // form inputs
  const saveButtons = document.querySelectorAll('.account-settings-group .save-button')
  saveButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      let nearestGroup = button.closest('.account-settings-group-input')
      if (!nearestGroup) {
        nearestGroup = button.closest('.account-settings-group')
      }
      if (!nearestGroup) {
        return false
      }
      const targetEndpoint = nearestGroup.dataset.accountSettingsEndpoint
      if (!targetEndpoint) {
        console.log('bailing because no endpoint for button', nearestGroup)
        return false
      }
      const inputForms = nearestGroup.querySelectorAll('input')
      const payloadUpdates = {
        id: window.account_customer_id
      }
      for (let i = 0; i < inputForms.length; i++) {
        const input = inputForms[i]
        const inputName = input.name
        const inputValue = input.value
        payloadUpdates[inputName] = inputValue
      }
      button.innerText = 'SAVING CHANGES'
      const currentErrorFields = nearestGroup.querySelectorAll('.form-error')
      currentErrorFields.forEach((errorField) => {
        errorField.remove()
      })
      fetch('https://asqecxs6u1.execute-api.us-west-2.amazonaws.com/dev/accounts/' + targetEndpoint, {
        method: 'POST',
        body: JSON.stringify(payloadUpdates),
        headers: {
          'Content-Type': 'application/json',
          'X-Credo-Account-Access-Key': window.account_update_token
        }
      }).then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          button.innerText = 'SAVE CHANGES'
          const formInputWrappers = button.closest('.edit').querySelectorAll('.input-wrapper')
          const lastInputWrapper = formInputWrappers[formInputWrappers.length - 1]
          const errorMessageEl = document.createElement('div')
          errorMessageEl.classList.add('warning-message')
          errorMessageEl.classList.add('form-error')
          errorMessageEl.innerText = data.error || 'Unknown error'
          lastInputWrapper.insertAdjacentElement('afterend', errorMessageEl)
        }
        return data
      }).then((data) => {
        if (data.status === 'OK') {
          // #TODO: Update values inline if possible?
          window.location.reload()
        }
      }).catch((error) => {
        console.error(error)
        button.innerText = 'SAVE CHANGES'
      })
      return false
    })
  })

  // Also check nav links on page load
  const accountSections = document.querySelectorAll('.account-section')
  const pageHash = window.location.hash
  if (pageHash) {
    let target = pageHash.replace('#', '')
    let link = document.querySelector('.account-nav li a[data-account-tab-target="' + target + '"]')
    if (link) {
      navLinks.forEach((link) => { link.parentElement.classList.remove('selected') })
      link.parentElement.classList.add('selected')
      const selectedSections = document.querySelectorAll('.account-section[data-account-tab="' + target + '"]')
      if (selectedSections.length > 0) {
        accountSections.forEach((section) => { section.classList.remove('selected') })
        selectedSections.forEach((section) => { section.classList.add('selected') })
        const pageTitle = document.querySelector('.customer-hero .title')
        pageTitle.innerText = formatSentenceCase(link.innerText)
      }
      const accountContainer = document.querySelector('.account-container')
      if (target === 'rewards' || target === 'wishlist') {
        accountContainer && accountContainer.classList.add('no-sidebar')
      } else if (accountContainer.classList.contains('no-sidebar')) {
        accountContainer && accountContainer.classList.remove('no-sidebar')
      }
    }
  }

})

const showBody = document.querySelector('.show-body')
if (showBody) showBody.style.display = 'none'

// Rewards event listener
function formatMoney(price, currency = 'USD') {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(price).replace('.00', '')
}
const messages = [
  'Trying to call your points but they haven’t answered yet.',
  'Free products are worth the wait.',
  'Patience is a virtue. But also this is taking a while.',
  'While we wait, have I told you you look stunning today?',
  'Haiku: This loading slow. Credo\'s rewards are worth it. Please wait a minute.',
  'The best gifts in life are worth a little patience.',
  'Patience is golden, but these points are testing me!',
  'As we eagerly wait, did you notice how the time seems to slow?',
  'Haiku: Points accumulating. Anticipation grows. Patience is rewarded.',
  'Waiting for points, like waiting for a call back from a crush.',
  'Good things come to those who wait… and wait… and wait.',
  'The anticipation builds, as does your point balance.',
  'Ever tried holding your breath while waiting? Just kidding, don’t!',
  'It’s not the wait that’s long; it’s the anticipation that’s killing me!',
  'While points are on their way, let’s admire the journey.',
  'Haiku: Loading takes its time. But rewards are on their way. Breathe in, breathe out, wait.',
  'A watched account never accrues – look away for a surprise!',
  'Remember, the longer the wait, the sweeter the reward.',
  'The clock ticks slowly, but the points will surely come.',
  'Patience, my friend, the points are just around the corner.',
  'Every tick of the clock brings us closer to the prize.',
  'They say good things take time; these points are no exception.',
  'The longer the wait, the greater the excitement.',
  'In this game of patience, the points are the ultimate prize.',
  'As we wait, let’s imagine the joy of spending those points.'
]
const waitingMessageElement = document.querySelector('.waiting-message')
let currentIndex = -1
function updateMessage() {
  let newIndex
  do {
    newIndex = Math.floor(Math.random() * messages.length)
  } while (newIndex === currentIndex)
  currentIndex = newIndex
  if (waitingMessageElement) {
    waitingMessageElement.textContent = messages[currentIndex]
  }
}
updateMessage()
const intervalCNId = setInterval(updateMessage, 10000)

// Rewards event listener
document.addEventListener('swell:setup', function() {
  const customerDetails = swellAPI.getCustomerDetails()
  console.log('Swell customer details: ', customerDetails)
  if (!customerDetails || !customerDetails.vipTier) {
    return false
  }
  const rewardsSummaries = document.querySelectorAll('.rewards-summary')
  const vipTier = customerDetails.vipTier
  const cusPoints = customerDetails.pointsBalance
  const cusTierIndex = Number(vipTier.name.split(' ')[1])
  const cusSpendToNextTier = customerDetails.vipTierStatsNeeded ? customerDetails.vipTierStatsNeeded.amountSpentCents : null
  rewardsSummaries.forEach((summary) => {
    const tierLevelLabel = summary.querySelector('.tier-level')
    if (tierLevelLabel) {
      tierLevelLabel.innerText = cusTierIndex
      tierLevelLabel.classList.remove('tier-1')
      tierLevelLabel.classList.remove('tier-2')
      tierLevelLabel.classList.remove('tier-3')
      tierLevelLabel.classList.add(`tier-${cusTierIndex}`)
    }

    const pointsLabels = summary.querySelectorAll('[data-rewards-badge-text]')

    pointsLabels.forEach((pointsLabel) => {
      pointsLabel.innerText = `${cusPoints} pts`
    })
  

    const togoLabel = summary.querySelector('.rewards-badge-to-go-text')
    if (togoLabel) {
      if (cusSpendToNextTier) {
        togoLabel.innerText = `Spend ${formatMoney(cusSpendToNextTier * 0.01)} to reach Tier ${cusTierIndex + 1}`
      } else {
        togoLabel.remove()
      }
    }
    if (cusPoints && togoLabel && tierLevelLabel) {
      document.querySelector('.loading-body').style.display = 'none'
      document.querySelector('.show-body').style.display = 'flex'
      clearInterval(intervalCNId)
    }
  })

  const myBenefits = document.querySelector('.account-settings-group.my-benefits')
  if (myBenefits) {
    const tierTitleText = myBenefits.querySelectorAll('.tier-number-text')
    tierTitleText.forEach((titleText) => {
      titleText.innerText = cusTierIndex
    })
    const viewAllButton = myBenefits.querySelector('.view-link')
    viewAllButton.addEventListener('click', (e) => {
      e.preventDefault()
      const benefitsList = document.querySelector('.account-settings-group.all-benefits')
      const benefitsRect = benefitsList.getBoundingClientRect()
      const stickyHeader = document.querySelector('sticky-header')
      const headerRect = stickyHeader.getBoundingClientRect()
      const scrollPosition = benefitsRect.top + window.scrollY - headerRect.bottom
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' })
      return false
    })
    const benefitsList = myBenefits.querySelectorAll('.benefits-list')
    benefitsList.forEach((benefit) => {
      benefit.style.display = 'none'
    })
    const applicableBenefitList = myBenefits.querySelector(`.benefits-list.tier-${cusTierIndex}`)
    applicableBenefitList.style.display = 'flex'
  }
})

// Notification Settings
const accountSettingsTogglesArray = document.querySelectorAll('[data-account-settings-toggle-line]')
const closePopupButtons = document.querySelectorAll("[data-notifications-popup-close]")

// Close Notification Popup
closePopupButtons.forEach((closeBtn) => {
  closeBtn.addEventListener('click', (e) => {
    e.preventDefault()
    const openedPopup = document.querySelector('.notifications-popup.popup-active')
    openedPopup && openedPopup.classList.remove('popup-active')
  })
})
function requiredCheckApproved(notificationPopup, subject) {
  const input = notificationPopup.querySelector(`[data-notifications-popup-${subject}-phone-input`)
  if (input && input.hasAttribute('required') && input.value === '') {
    return false
  }
  return true
}
function termsCheckboxListeners(notificationPopup, subject) {
  const termsLabel = notificationPopup.querySelector('[data-notifications-terms-label]')
  const termsCheckbox = notificationPopup.querySelector('[data-notifications-terms-checkbox]')
  const submitButton = notificationPopup.querySelector(`[data-notifications-popup-${subject}-save-btn]`)
  const termsLabelLinks = notificationPopup.querySelectorAll('[data-notifications-terms-label] a')
  if (!termsLabel || !termsCheckbox || !submitButton) {
    console.log("Checkbox elements not found")
    return
  }

  termsLabel.addEventListener('click', (e) => {
    e.preventDefault()
    if (termsCheckbox.checked === false && requiredCheckApproved(notificationPopup, subject)) {
      termsCheckbox.checked = true
      submitButton.classList.remove('disabled')
      submitButton.removeAttribute('disabled')
    } else {
      termsCheckbox.checked = false
      submitButton.classList.add('disabled')
      submitButton.setAttribute('disabled', 'disabled')
    }
  })
  termsLabelLinks.forEach((link) => {
    link && link.addEventListener('click', (e) => { e.stopPropagation() })
  })
}
function toggleClicked(toggleLine) {
  const fieldInput = toggleLine.querySelector('[data-account-settings-toggle-input]')
  const fieldSubject = fieldInput.dataset.accountSettingsToggleInput
  const notificationPopup = document.querySelector(`[data-notifications-popup-${fieldSubject}]`)
  // Check/Uncheck
  if (fieldInput.hasAttribute('checked')) {
    notificationPopup && fieldInput.removeAttribute('checked')
  } else {
    notificationPopup && fieldInput.setAttribute('checked', 'checked')
  }
  // Open Popup
  if (notificationPopup) notificationPopup.classList.add('popup-active')
  termsCheckboxListeners(notificationPopup, fieldSubject)
}
function initAccountSettingsToggleLister () {
  accountSettingsTogglesArray.forEach((toggleLine) => {
    const toggleField = toggleLine.querySelector('[data-account-settings-toggle-label]')
    if (!toggleField) {
      console.log('No label toggle found')
      return
    }
    toggleField.addEventListener('click', (e) => {
      e.preventDefault()
      toggleClicked(toggleLine)
    })
  })
}
function onPageLoad() {
  if (accountSettingsTogglesArray) initAccountSettingsToggleLister()
}
document.addEventListener('DOMContentLoaded', onPageLoad)
// End - Notification Settings